import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function EMIStageCollectionChart({ stages }) {
  const data = (stages || []).map((stage) => ({
    stage: stage.stageLabel,
    loans: stage.activeLoans,
    amount: stage.collectionAmount,
  }));

  const formatCurrency = (value) => `₹${(value / 100000).toFixed(2)}L`;

  return (
    <div className="">
      <h4
        style={{
          fontSize: "20px",
          marginBottom: "24px",
          marginTop: "10px",
          fontWeight: "600",
          color: "#0A0A0A",
        }}
      >
        Collection Performance by EMI Stage
      </h4>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <CartesianGrid strokeDasharray="3 3" vertical={false} />

          <XAxis dataKey="stage" />

          <YAxis yAxisId="left" />

          <YAxis
            yAxisId="right"
            orientation="right"
            tickFormatter={formatCurrency}
          />

          <Tooltip
            formatter={(value, name) => {
              if (name === "Collection Amount") {
                return formatCurrency(value);
              }
              return value;
            }}
          />

          <Legend />

          <Bar
            yAxisId="left"
            dataKey="loans"
            name="Number of Loans"
            fill="#3B82F6"
            radius={[4, 4, 0, 0]}
          />

          <Bar
            yAxisId="right"
            dataKey="amount"
            name="Collection Amount"
            fill="#10B981"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
